import {useMemo} from 'react';
import {useIntl} from 'react-intl';

import {useSiteClientData} from '@amblique/king-living/app/hooks/use-site-client-data';
import {
  getPasswordValidationPreferenceId,
  resolvePasswordValidationMessages,
} from '@amblique/king-living/app/utils/password-validation-messages';

/**
 * Loads password rule validation messages from BM site preferences via Custom SCAPI.
 * Uses `newPasswordValidationMessage` for reset password only; all other contexts use
 * `passwordValidationMessage`. Falls back to i18n when BM value is missing.
 *
 * @param {'login'|'registration'|'update'|'reset'} [context='registration'] - i18n fallback key namespace
 * @returns {{message: string, isLoading: boolean}}
 */
export const usePasswordValidationMessages = (context = 'registration') => {
  const {formatMessage} = useIntl();
  const preferenceId = getPasswordValidationPreferenceId(context);
  const {data: response, isLoading} = useSiteClientData();
  const bmMessage = response?.clientData?.preferences?.[preferenceId];

  const message = useMemo(
    () => resolvePasswordValidationMessages(bmMessage, formatMessage, context),
    [bmMessage, formatMessage, context]
  );

  return {
    message,
    isLoading,
  };
};
